import {useAppSelector} from '../../../../../../../../../../hooks/react-redux'
import {getJobName} from '../../../../../../../EditPipelinePage/EditPipelinePage.selectors'
import {usePipelineId} from '../../../../../../../hooks/pipeline'

type Props = {
  dependencies: string[]
}

export function JobDependenciesNote({dependencies}: Props) {
  const id = usePipelineId()
  const note = useAppSelector(state =>
    dependencies.map(depId => getJobName(state, id, depId)).join(', '),
  )
  return <>{note}</>
}
